var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('ArabicNumber',{attrs:{"number":_vm.finalAmount}}),_vm._v(" "),(_vm.withCurrency)?_c('span',[_vm._v("ريال")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }